import actions from 'actions';
import {
  SPOT_DESCRIPTION_SYSTEM_PROMPT,
  getSpotDescriptionSubject,
  getSpotDescriptionUserPrompt,
} from 'utils/spotDescription';

// The suggestion already carries the reverse-geocoded city that built the slug.
// When it is missing, fall back to the same live lookup /moderation performs so
// the subject does not silently degrade to country-only.
const getCity = async ({ spot, city }) => {
  const knownCity = String(city || '').trim();

  if (knownCity) {
    return knownCity;
  }

  const place = await actions.google.getPlace(spot.lat, spot.lng).catch(() => null);
  return String((place && place.city) || '').trim();
};

// Same endpoint, same system prompt, and same save/translate chain the
// DescriptionForm on /moderation runs after a spot is created.
// A spot costs far more than the suggestion that proposed it: the description
// is one SOL call at high reasoning effort, and translating it is twenty-nine
// TERRA calls. Both come out of the same complimentary allowances the budget
// bar is drawn from, and neither used to appear there.
export const generateSpotDescription = async ({ spot, city, onUsage }) => {
  const countUsage = entry => {
    if (typeof onUsage === 'function' && entry) {
      onUsage(entry);
    }
  };
  const subject = getSpotDescriptionSubject({ spot, city: await getCity({ spot, city }) });
  const answer = await actions.openai.getResponse(
    SPOT_DESCRIPTION_SYSTEM_PROMPT,
    getSpotDescriptionUserPrompt(subject),
    countUsage
  );
  const description = String(answer || '').trim();

  if (!description) {
    throw new Error('The model returned an empty description.');
  }

  await actions.spots.edit(spot, { description: { en: description } });

  const translation = await actions.spots.translateDescription(spot);

  ((translation && translation.usage) || []).forEach(countUsage);

  return { subject, description };
};

export default generateSpotDescription;
